


















































































































import { Component, Prop, Emit, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import { dateTimeToDisplay, dateToDisplay } from '@/utils/dateTime'
import { Quote } from '@/modules/Quote/interfaces/quote'
import FoldingCard from '@/components/FoldingCard.vue'
import AppFileUploader from '@/components/AppFileUploader.vue'
import S3Handler from '@/mixins/s3'
import PolicyDialog from '@/modules/Policy/scripts/policy-dialog'
import VehicleDialog from '@/modules/Vehicle/scripts/vehicle-dialog'
import InsuredDialog from '@/modules/Insured/scripts/insured-dialog'
import PropertyDialog from '@/modules/Property/scripts/property-dialog'
import { translateInsuredRelatioKey } from '@/utils/translate'
import AppAttachmentsCard from '@/components/AppAttachmentsCard.vue'
import { Policy } from '@/modules/Policy/interfaces/policy'
import { RecordType } from '@/modules/RecordType/interfaces/record-type'

@Component({
  components: {
    FoldingCard,
    AppFileUploader,
    AppAttachmentsCard
  }
})
export default class QuoteDetailRelated extends mixins(PolicyDialog, S3Handler, VehicleDialog, InsuredDialog, PropertyDialog) {
  @Prop({ type: Object as () => Quote }) readonly quote!: Quote
  @Prop({ type: Object as () => RecordType }) readonly recordType!: RecordType

  dateTimeToDisplay = dateTimeToDisplay
  dateToDisplay = dateToDisplay

  vehicleTableColumn = [
    { field: 'name',
      title: 'Vehicle Name',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', { class: 'text-emphasize' }, row.name)
        ]
      }
      },
      resizable: true
    },
    { field: 'vin',
      title: 'VIN',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.vin)
        ]
      }
      },
      resizable: true
    },
    { field: 'year',
      title: 'Year',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.year)
        ]
      }
      },
      resizable: true
    },
    { field: 'model',
      title: 'Model',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.model)
        ]
      }
      }
    }
  ]

  propertyTableColumn = [
    { field: 'address',
      title: 'Address',
      slots: { default: 'address_default' },
      resizable: true
    },
    { field: 'city',
      title: 'City',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.city || '-')
        ]
      }
      },
      resizable: true
    },
    { field: 'state',
      title: 'State',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.state || '-')
        ]
      }
      }
    }
  ]

  insuredTableColumn = [
    { field: 'name',
      title: 'Insured Name',
      slots: { default: 'insured_name_default' },
      resizable: true
    },
    { field: 'relationShip',
      title: 'Relationship',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.relationShip ? translateInsuredRelatioKey(row.relationShip) : '-')
        ]
      }
      },
      resizable: true
    },
    { field: 'dateOfBirth',
      title: 'Date Of Birth',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.dateOfBirth || '-')
        ]
      }
      }
    }
  ]

  additionalInfoCards: {
    title: string;
    items: {[key: string]: any;}[]
  }[] = []

  quoteAdditional: {
    [key: string]: any;
  } = {}

  get attachmentList () {
    return this.quote.attachments || []
  }

  get showAuto () {
    if (!this.quote) {
      return false
    }
    const { name } = this.quote.recordType

    return name.indexOf('Auto') !== -1
  }

  get vehicles () {
    if (!this.quote) {
      return []
    }

    return this.showAuto
      ? this.quote.vehicles
      : []
  }

  get insureds () {
    if (!this.quote) {
      return []
    }

    return this.quote.insureds
  }

  get properties () {
    if (!this.quote) {
      return []
    }

    return this.quote.properties
  }

  mounted () {
    this.onRecordTypeChanged(this.recordType)
  }

  @Watch('recordType', { deep: true })
  onRecordTypeChanged (val: RecordType) {
    if (!this.quote || !val) {
      return
    }

    this.additionalInfoCards = val.additionalInfo
    this.quoteAdditional = JSON.parse(this.quote.additionalInfoStr)
  }

  @Emit('success')
  onSuccess () {
    // do nothing
  }

  @Emit('edit')
  editQuote (step: number) {
    return step
  }

  routeToDetail (item: any) {
    this.$router.push({
      name: 'PolicyDetailDetail',
      params: {
        id: item.id
      }
    })
  }

  async deletePolicyConfirm () {
    await this.deletePolicyPost()
    this.onSuccess()
  }

  routeToAllList (type: string) {
    this.$router.push({
      name: 'QuoteRelatedPoliciesList',
      params: {
        id: this.quote.id + ''
      }
    })
  }

  newVehicle (e: Event) {
    e.preventDefault()
    e.stopPropagation()
    this.showVehicleEditDialog(e)
  }

  newInsured (e: Event) {
    e.preventDefault()
    e.stopPropagation()
    this.showInsuredEditDialog(e)
  }

  newProperty (e: Event) {
    e.preventDefault()
    e.stopPropagation()
    this.showPropEditDialog(e)
  }

  clearForm () {
    this.hideVehicleEditDialog()
    this.hideInsuredEditDialog()
    this.hidePropEditDialog()
  }

  routeToList (routeName: string) {
    this.$router.push({
      name: routeName,
      params: {
        quoteId: this.quote.id + ''
      }
    })
  }

  routeToPropertyDetail (item: any) {
    this.$router.push({
      name: 'PropertyDetailDetail',
      params: { id: item.id + '' }
    })
  }

  routeToInsuredDetail (item: any) {
    this.$router.push({
      name: 'InsuredDetailDetail',
      params: { id: item.id + '' }
    })
  }

  stopPreventDefault (e: Event) {
    e.preventDefault()
    e.stopPropagation()
  }

  mergeCellMethod ({ row, _rowIndex, column, visibleData }: any) {
    const fields = ['name']
    const cellValue = row[column.property]
    if (cellValue && fields.includes(column.property)) {
      const prevRow = visibleData[_rowIndex - 1]
      let nextRow = visibleData[_rowIndex + 1]
      if (prevRow && prevRow['acordFormId'] === row['acordFormId']) {
        return { rowspan: 0, colspan: 0 }
      } else {
        let countRowspan = 1
        while (nextRow && nextRow['acordFormId'] === row['acordFormId']) {
          nextRow = visibleData[++countRowspan + _rowIndex]
        }
        if (countRowspan > 1) {
          return { rowspan: countRowspan, colspan: 1 }
        }
      }
    }
  }

  cellClassName (data: any) {
    if (data.column.property === 'name') {
      return 'file-name-cell'
    }
  }

  editPolicy (e: Event, policy: Policy) {
    e.preventDefault()
    e.stopPropagation()
    this.showPolicyEditDialog(0, policy)
  }
}
